import React from 'react';
import FeedPresenterSpotlight from '../main-video/feed-presenter-spotlight';
import MediaVideoSpotlight from './media-video-spotlight';
import FeedScreenShareSpotlight from '../main-video/feed-screenshare-spotlight';
import Socket from '../../connection/socket';
import FeedMediaSpotlight from '../main-video/feed-media-spotlight';

const componentMap = {
	presenter: FeedPresenterSpotlight,
	media: FeedMediaSpotlight, // MediaVideoSpotlight, //,
	audio: FeedMediaSpotlight,
	screenshare: FeedScreenShareSpotlight,
	containermedia: FeedMediaSpotlight,
};

export const propMap = {
	presenter: (key: number, position: number) => ({
		mediaId: key,
		feedPosition: position,
	}),
	media: (
		key: number,
		position: number,
		isAudioOnly:boolean,
		isPreloading:boolean,
		iterateLoadedMediaCount?: Function,
		socket?: Socket | null,
	) => ({
		mediaId: key,
		feedPosition: position,
		className: 'media-video',
		iterateLoadedMediaCount,
		socket,
		isPreloading: false,
		doEchoCancel: true,
		audioOnly: isAudioOnly,
		isEditingFeed: false,
		isForMainVideoEditingComponent: false,
	}),
	audio: (
		key: number,
		position: number,
		isAudioOnly:boolean,
		isPreloading:boolean,
		iterateLoadedMediaCount?: Function,
		socket?: Socket | null,
	) => ({
		mediaId: key,
		feedPosition: position,
		className: 'media-video',
		iterateLoadedMediaCount,
		socket,
		isPreloading: false,
		doEchoCancel: true,
		audioOnly: isAudioOnly,
		isEditingFeed: false,
		isForMainVideoEditingComponent: false,
	}),
	screenshare: (key: number, position: number) => ({
		mediaId: key,
		feedPosition: position,
	}),
};

export default function DynamicComponent(
	{ type, ...props }:{type: string, child: JSX.Element, props:{[key: string]: any} | null},
) {
	// @ts-ignore
	const Component = componentMap[type];

	if (!Component) return null;
	return (
        <Component {...props.props} >
            {props.child}
        </Component>
	);
}
